import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DriverTask } from 'src/app/classes/driver-task';
import { Events } from 'src/app/classes/events';
import { TaskBarData } from 'src/app/classes/task-bar-data';
import { BRAND_ICON_URL } from 'src/app/common/constants';
import { AlertService, MeatBallData } from 'src/app/services/alert.service';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { NavService } from 'src/app/services/nav.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ConfirmLogoutDialogComponent } from '../confirm-logout-dialog/confirm-logout-dialog.component';

@Component({
  standalone: false,
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: [ './nav-bar.component.scss' ]
})
export class NavBarComponent implements OnInit, OnDestroy {
  public title = `CVV`;
  public accountName = '';
  public accountAdId = '';
  public darkModeToggle = new FormControl(false);
  public BRAND_ICON_URL = BRAND_ICON_URL;
  @Output() drawer: EventEmitter<any> = new EventEmitter();
  @Output() drawer1: EventEmitter<any> = new EventEmitter();

  // @Output() openTasks: EventEmitter<any> = new EventEmitter();
  unsubscribe$: Subject<boolean> = new Subject();
  taskBarData: TaskBarData;
  showTaskBar = false;
  driverTasksDueInfoBigText = '';
  minsUntilDue = '';
  driverTasks: Array<DriverTask>;
  events: Events;
  showMeatball = false;
  meatballValue = 0;

  constructor(
    private profileService: ProfileService,
    private navService: NavService,
    private msalService: MsalService,
    private eventsService: EventsService,
    private eventsDeltaService: EventsDeltaService,
    private utilsService: UtilitiesService,
    private dialog: MatDialog,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.subscribeToProfile();
    this.subscribeToEvents();
    this.subscribeToEventDeltas();
    this.subscribeToMeatballData();
  }

  openPanel(panel: string): void{
    // this.openTasks.emit(true);
    this.navService.setPanelObs(panel);
  }

  subscribeToProfile(): void {
    this.profileService.getProfileObs().pipe(takeUntil(this.unsubscribe$)).subscribe((profile) => {
      if (profile && profile.firstName && profile.lastName) {
        this.accountName = this.profileService.makeAccountName(profile);
        this.accountAdId = profile.adId;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  toggle(name: string): void {
    if (name === 'drawer') {
      this.navService.setDrawerObs('drawer');
    } else {
      this.navService.setDrawerObs('drawer1');
    }
  }

  logout(): void {
    if ((this.driverTasks || []).find((task: DriverTask) => task.assignTo === this.accountAdId)) {
      this.dialog.open(ConfirmLogoutDialogComponent, {
        position: {top: '0'}
      }).afterClosed().subscribe((confirm: boolean) => {
        if (confirm) {
          this.msalService.logout();
        }
      })
    } else {
      this.msalService.logout();
    }
  }


  updateTaskBar(taskBarData: TaskBarData): void {
    let taskBarInfoDisplayText = null;
    const totalStops = taskBarData.countOfStops;
    const passCountInVan = taskBarData.passengerCountInVan;
    this.minsUntilDue = taskBarData.dueTime
    const totalAssigned = taskBarData.countOfAssigned;
    if(totalStops > 0 || totalAssigned > 0){
      this.showTaskBar = true;
      let assignmentWord = "Assignments";
      if (totalAssigned == 1) {
        assignmentWord = "Assignment";
      }
      var passengerWord = "Passengers";
      if (passCountInVan == 1) {
        passengerWord = "Passenger";
      }
      var stopWord = "Stops";
      if (totalStops == 1) {
        stopWord = "Stop";
      }
      if (totalAssigned > 0 && totalStops == 0) {
        this.showTaskBar = true;
        this.driverTasksDueInfoBigText = `${totalAssigned} ${assignmentWord}`;
        return;
      }
      if (passCountInVan == 0) {
        taskBarInfoDisplayText = "Waiting for Pick up";
      } else {
        taskBarInfoDisplayText = passCountInVan + " " + passengerWord + " / " + totalStops + " " + stopWord;
      }
      this.driverTasksDueInfoBigText = `${taskBarInfoDisplayText}`;
    }
  }


  subscribeToEvents(): void {
    this.eventsService.getEventData().pipe(takeUntil(this.unsubscribe$)).subscribe((events) => {
      if (events) {
        this.events = events;
        this.driverTasks = events['driverTasks'];
        if (this.driverTasks && this.driverTasks.length > 50) {
          this.driverTasks = this.driverTasks.slice(0, 50);
        }
        if (this.driverTasks && this.driverTasks.length > 0) {
          this.processAssignedTasks();
        }else{
          // no tasks
          this.minsUntilDue = '';
          this.showTaskBar = false;
        }
      }
    });
  }

  subscribeToEventDeltas(): void {
    this.eventsDeltaService.getEventData().pipe(takeUntil(this.unsubscribe$)).subscribe((events) => {
      if (events) {
        this.events = events;
        const driverTaskStatus = events['driverTaskStatus'];
        switch (driverTaskStatus) {
          case 'none':
            this.driverTasks = [];
            this.minsUntilDue = '';
            this.showTaskBar = false;
            break;
          case 'updated':
            this.driverTasks = events['driverTasks'];
             if (this.driverTasks && this.driverTasks.length > 50) {
              this.driverTasks = this.driverTasks.slice(0, 50);
            }
            if (this.driverTasks && this.driverTasks.length > 0) {
              this.processAssignedTasks();
            }else{
              // no tasks
              this.minsUntilDue = '';
              this.showTaskBar = false;
            }
            break;
          default:
            break;
        }
      }
    });
  }

  processAssignedTasks(){

      let taskBarData = new TaskBarData();
      taskBarData.plannedCompleteTime = this.driverTasks[0].plannedEnd || null
      taskBarData.dueTime = this.getdueTime(this.driverTasks[0].plannedEnd) || null;

      this.driverTasks.forEach((task) => {
        if(task.status === 'Started'){
          taskBarData.countOfStops++;
          taskBarData.startedTasksArray.push(task.taskName);
        }

        if (task.assignTo.toUpperCase() === this.profileService.profileObs$.getValue().adId.toUpperCase()) {
          if (task.status == "Assigned") {
            taskBarData.assignedTasksArray.push(task.taskName);
          }
          if (task.status == "Assigned" || task.status == "Started") {
            taskBarData.countOfAssigned++;
          }
        }

        if (task.passengers?.length > 0 && task.typeName == "InboundFlight" || task.typeName == "OutboundFlight") {
          taskBarData.hasPassengers = true;
          task.passengers.forEach(() => {
            (task.status === 'Started' ? taskBarData.passengerCountInVan++ : taskBarData.passengerCountNotInVan++);
          });
        }

        if(task.addOnDetails?.length > 0){
          task.addOnDetails.forEach((item) => {
            if (task.status == "Started" && item.type == "Passenger") {
              taskBarData.passengerCountInVan++;
            }
            if (task.status !== "Started" && item.type == "Passenger") {
              taskBarData.passengerCountNotInVan++;
            }
          });
        }

      });
     this.updateTaskBar(taskBarData);
  }

  getdueTime(date: string): any {
    return this.utilsService.timeMath(date);
  }


  subscribeToMeatballData(){
    this.alertService.getMeatballData()
    .pipe(
      takeUntil(this.unsubscribe$))
    .subscribe((data: MeatBallData) => {
      if(data){
      const total = data.coordinator + data.driver;
      if(total === 0){
        this.showMeatball = false;
        this.meatballValue = 0;
      }else{
        this.showMeatball = true;
        this.meatballValue = total;
      }
    }
    });
  }

}
